
<ng-container>
    <p-contextMenu #taskContextMenu [model]="contextMenuItems" (onShow)="populateContextMenu()">
    </p-contextMenu>
    <p-table [value]="taskList" [rows]="pageSize" [showCurrentPageReport]="true"
    [rowsPerPageOptions]="tableShowMore" [paginator]="true" [(selection)]="selectedTask"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    (onRowSelect)="editViewTask($event, true)"  (onRowUnselect)="selectedTask = null;"
    [filterDelay]="0" [totalRecords]="totalRecords"
    [(contextMenuSelection)]="selectedTask" [contextMenu]="taskContextMenu"
    (onLazyLoad)="getAllTasksWithPagination($event)" [lazy]="true" [(first)]="first"
    dataKey="id" selectionMode="single" [resizableColumns]="true"
    [columns]="cols" [scrollable]="true" [showJumpToPageInput]="true"
    styleClass="p-datatable-gridlines floatthead task-table" #taskTable 
    appFloatThead [forceReflow]="forceReflow" [showFloatHeader]="showFloatHeader" [floatTableRef]="taskTable" 
    floatTableClassRef="floatthead" [expandableRows]="true">
        <!-- <ng-template pTemplate="caption">
            <div class="table-header">
                <div class="p-grid p-mt-0">
                    <div class="p-col-8 p-text-right">
                        <button pButton pRipple type="button" label="Filter" icon="pi pi-plus"
                        (click)="filter.toggle($event)" class="p-mr-3"></button>
                         <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" placeholder="Search..." [formControl]="searchControl" />
                        </span> 
                    </div>
                </div>
            </div>
        </ng-template> -->
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngIf="selectedGroupByValue" style="border-right: 1px solid var(--primary-color);" pResizableColumn
                    [ngClass]="{'filtered-column': filterInColumns?.includes(selectedGroupByValue.name)}">
                    <div class="p-d-flex p-ai-center">
                        <button type="button" pButton pRipple class="p-button-text p-button-rounded p-button-plain group-expand-button"
                            (click)="onAllGroupExpand()" [pTooltip]="groupAllExpanded ? 'Collapse All': 'Expand All'"
                            [icon]="groupAllExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                        </button> Group: {{selectedGroupByValue.name}}
                    </div>
                </th>
                
                <ng-container *ngFor="let col of columns">
                    <th [pSortableColumn]="col.columnName" *ngIf="col?.enabled  && col.columnName == 'details'"  [ngClass]="{'filtered-column': filterInColumns?.includes(col.columnName)}"
                    class="detail-column" style="min-width: 250px;width: 250px;"
                    style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                        {{col.name}}
                        <p-sortIcon [field]="col.columnName"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="col.columnName" *ngIf="col?.enabled && col.columnName !== 'details' && (selectedGroupByValue?.columnName!=col.columnName)"
                    class="detail-column" style="min-width: 250px;width: 250px;"
                    style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                        {{col.name}}
                        <p-sortIcon *ngIf="col.columnName === 'id'" [field]="col.columnName"></p-sortIcon>
                    </th>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr class="parentRow" *ngIf="selectedGroupByValue">
                <td colspan="30" class="group-expand-row">
                    <div class="p-d-flex p-ai-center">
                        <button type="button" pButton pRipple
                            class="p-button-text p-button-rounded p-button-plain group-expand-button"
                            (click)="onGroupExpand(rowData)"
                            [icon]="rowData?.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                        </button>
                        <span [pTooltip]="rowData.groupByValue">
                            @switch (selectedGroupByValue?.fieldDataType) {
                                @case ('DateTime') {
                                    {{ selectedGroupByValue.name }} - {{ rowData.groupByValue ? (rowData.groupByValue | date:'MM/dd/yyyy') : 'NA' }} ({{rowData.totalCount}})
                                }
                                @default {
                                    @if(rowData?.colorCode){
                                        {{ selectedGroupByValue.name }} - 
                                    <p-tag [value]="rowData.groupByValue || 'NA'"
                                           [style]="{'background-color': rowData.colorCode}"
                                           severity="info">
                                    </p-tag>
                                    ({{rowData.totalCount}})
                                    }@else {
                                        {{ selectedGroupByValue.name }} - {{ rowData.groupByValue ? (rowData.groupByValue | shorten:27) : 'NA' }} ({{rowData.totalCount}})

                                    }
                                }
                            }
                        </span>
                    </div>
                </td>
            </tr>
            <!-- GroupBy Listing -->
            @if (selectedGroupByValue && rowData?.expanded && rowData?.tasks?.length > 0) {
                @for (task of rowData.tasks; track task.id) {
                    <tr [pSelectableRow]="task" [pContextMenuRow]="task">
                        @if (selectedGroupByValue) {
                            <td style="text-align: left;"></td>
                        }
                        
                        @for (col of columns; track col.columnName) {
                            @if (col?.enabled && selectedGroupByValue?.columnName!=col.columnName) {
                                <td style="text-align: left;">
                                    @if (col.columnName == 'id') {
                                        @switch (task?.taskTypeId) {
                                            @case (TaskType.Group) {
                                                <span class="pi pi-users" 
                                                      style="color:var(--primary-color)"
                                                      pTooltip="Multiple Task"
                                                      tooltipPosition="left">
                                                </span>
                                                {{ task[col.columnName] }}
                                            }
                                            @case (TaskType.Individual) {
                                                <span class="pi pi-user" 
                                                      style="color:var(--primary-color)"
                                                      pTooltip="Single Task"
                                                      tooltipPosition="left">
                                                </span>
                                                {{ task[col.columnName] }}
                                            }
                                            @case (TaskType.Subtask) {
                                                <span class="pi pi-id-card" 
                                                      style="color:var(--primary-color)"
                                                      pTooltip="Sub-Task"
                                                      tooltipPosition="left">
                                                </span>
                                                {{ task['taskIds'] }}
                                            }
                                        }
                                    } @else {
                                        @switch (col?.fieldDataType) {
                                            @case ('DateTime') {
                                                {{ task[col.columnName] | localDate }}
                                            }
                                            @case ('String') {
                                                @if (col.columnName !== 'updatedBy') {
                                                    <span [innerHTML]="task[col.columnName] | shorten:50"></span>
                                                    @if (col.columnName == 'description' && task.attachmentStatus) {
                                                        <span class="pi pi-paperclip" 
                                                              pTooltip="Attachments" 
                                                              tooltipPosition="top"
                                                              style="color: var(--primary-color);">
                                                        </span>
                                                    }
                                                }
                                            }
                                            @default {
                                                @if (col.columnName == 'assignedTo') {
                                                    <p-avatarGroup styleClass="mb-3">
                                                        <p-avatar 
                                                            label="{{ task?.assignUser[getAssignedUserIndex(task)]?.assignedUser }}"
                                                            tooltipPosition="top" 
                                                            pTooltip="{{ task.assignedTo }}" 
                                                            shape="circle"
                                                            class="p-mr-1 custom-circle"
                                                            [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff' }" 
                                                        />
                                                        @if(task?.assignUser?.length > 1) {
                                                            <p-avatar 
                                                                label="+{{task?.assignUser?.length -1}}" 
                                                                shape="circle"
                                                                class="custom-circle" 
                                                                styleClass="p-ml-2"
                                                                [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff'}"
                                                                pTooltip="{{ task.assignedTo }}" 
                                                                tooltipPosition="top" 
                                                            />
                                                        }
                                                    </p-avatarGroup>
                                                } @else if (col.columnName == 'createdBy') {
                                                    <p-avatarGroup styleClass="mb-3">
                                                        <p-avatar 
                                                            label="{{task?.createdUser}}" 
                                                            pTooltip="{{ task.createdBy}}"
                                                            tooltipPosition="top" 
                                                            shape="circle" 
                                                            class="p-mr-1 custom-circle"
                                                            [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff' }" 
                                                        />
                                                    </p-avatarGroup>
                                                } @else if (col.columnName == 'updatedBy' && task.updatedBy) {
                                                    <p-avatarGroup styleClass="mb-3">
                                                        <p-avatar 
                                                            label="{{task?.updatedUser}}" 
                                                            pTooltip="{{ task.updatedBy}}"
                                                            tooltipPosition="top" 
                                                            shape="circle" 
                                                            class="p-mr-1 custom-circle"
                                                            [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff' }" 
                                                        />
                                                    </p-avatarGroup>
                                                } @else if (col.columnName == 'reassignTo' && task.reassignUser?.length>0) {
                                                    <p-avatarGroup styleClass="mb-3">
                                                        <p-avatar
                                                            label="{{ task?.reassignUser[getReassignedUserIndex(task)]?.assignedUser }}"
                                                            tooltipPosition="top" 
                                                            pTooltip="{{ task.reassignTo }}" 
                                                            shape="circle"
                                                            class="p-mr-1 custom-circle"
                                                            [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff' }" 
                                                        />
                                                        @if(task?.reassignUser?.length > 1) {
                                                            <p-avatar 
                                                                label="+{{task?.reassignUser?.length -1}}" 
                                                                shape="circle"
                                                                class="custom-circle" 
                                                                styleClass="p-ml-2"
                                                                [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff'}"
                                                                pTooltip="{{ task.reassignTo }}" 
                                                                tooltipPosition="top" 
                                                            />
                                                        }
                                                    </p-avatarGroup>
                                                } @else if (col.columnName == 'sharedUser' && task.sharedUser?.length>0) {
                                                    <p-avatarGroup styleClass="mb-3">
                                                        <p-avatar 
                                                            label="{{ task?.sharedUser[getSharedUserIndex(task)]?.assignedUser }}"
                                                            tooltipPosition="top" 
                                                            pTooltip="{{ task.sharedTo }}" 
                                                            shape="circle"
                                                            class="p-mr-1 custom-circle"
                                                            [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff' }" 
                                                        />
                                                        @if(task?.sharedUser?.length > 1) {
                                                            <p-avatar 
                                                                label="+{{task?.sharedUser?.length -1}}" 
                                                                shape="circle"
                                                                class="custom-circle" 
                                                                styleClass="p-ml-2"
                                                                [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff'}"
                                                                pTooltip="{{ task.sharedTo }}" 
                                                                tooltipPosition="top" 
                                                            />
                                                        }
                                                    </p-avatarGroup>
                                                } @else if (col.columnName === 'priority') {
                                                    <p-tag [value]="task[col.columnName]"
                                                          [style]="{'background-color': task.priorityColor}">
                                                    </p-tag>
                                                } @else if (col.columnName === 'status') {
                                                    <p-tag [value]="task[col.columnName]"
                                                          [style]="{'background-color': task.statusColor}">
                                                    </p-tag>
                                                } @else if (col.columnName === 'completionStatus') {
                                                    <span class="p-ml-1" id="label_status">
                                                        <strong>{{task.completedTask}}/{{task.totalTask}} Completed</strong>
                                                    </span>
                                                    <p-progressBar 
                                                        class="progress-bar-margin-top" 
                                                        [style]="{ width: '9rem' , height:'0.8rem'}"
                                                        aria-labelledby="label_status" 
                                                        [showValue]="true"
                                                        [value]="getCompletionRatio(task.completedTask,task.totalTask)">
                                                    </p-progressBar>
                                                } @else {
                                                    {{ task[col.columnName] | shorten:50 }}
                                                }
                                            }
                                        }
                                    }
                                </td>
                            }
                        }
                    </tr>
                }
            }
            <!-- Normal Listing -->
            @if (!selectedGroupByValue) {
                <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                    @for (col of columns; track col.columnName) {
                        @if (col?.enabled && rowData) {
                            <td>
                                @if (col.columnName == 'id') {
                                    @switch (rowData?.taskTypeId) {
                                        @case (TaskType.Group) {
                                            <span class="pi pi-users" 
                                                  style="color:var(--primary-color)"
                                                  pTooltip="Multiple Task"
                                                  tooltipPosition="left">
                                            </span>
                                            {{ rowData[col.columnName] }}
                                        }
                                        @case (TaskType.Individual) {
                                            <span class="pi pi-user" 
                                                  style="color:var(--primary-color)"
                                                  pTooltip="Single Task"
                                                  tooltipPosition="left">
                                            </span>
                                            {{ rowData[col.columnName] }}
                                        }
                                        @case (TaskType.Subtask) {
                                            <span class="pi pi-id-card" 
                                                  style="color:var(--primary-color)"
                                                  pTooltip="Sub-Task"
                                                  tooltipPosition="left">
                                            </span>
                                            {{ rowData['taskIds'] }}
                                        }
                                    }
                                } @else {
                                    @switch (col?.fieldDataType) {
                                        @case ('DateTime') {
                                            {{ rowData[col.columnName] | localDate }}
                                        }
                                        @case ('String') {
                                            @if (col.columnName !== 'updatedBy') {
                                                <span [innerHTML]="rowData[col.columnName] | shorten:50"></span>
                                                @if (col.columnName == 'description' && rowData.attachmentStatus) {
                                                    <span class="pi pi-paperclip" 
                                                          pTooltip="Attachments" 
                                                          tooltipPosition="top"
                                                          style="color: var(--primary-color);">
                                                    </span>
                                                }
                                            }
                                        }
                                        @default {
                                            @if (col.columnName == 'assignedTo') {
                                                <p-avatarGroup styleClass="mb-3">
                                                    <p-avatar *ngIf="rowData?.assignUser?.length"
                                                        label="{{ rowData?.assignUser[getAssignedUserIndex(rowData)]?.assignedUser }}"
                                                        tooltipPosition="top" 
                                                        pTooltip="{{ rowData?.assignedTo }}" 
                                                        shape="circle"
                                                        class="p-mr-1 custom-circle"
                                                        [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff' }" 
                                                    />
                                                    @if (rowData?.assignUser?.length > 1) {
                                                        <p-avatar 
                                                            label="+{{rowData?.assignUser?.length -1}}" 
                                                            shape="circle"
                                                            class="custom-circle" 
                                                            styleClass="p-ml-2"
                                                            [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff'}"
                                                            pTooltip="{{ rowData?.assignedTo }}" 
                                                            tooltipPosition="top" 
                                                        />
                                                    }
                                                </p-avatarGroup>
                                            } @else if (col.columnName == 'createdBy') {
                                                <p-avatarGroup styleClass="mb-3">
                                                    <p-avatar 
                                                        label="{{rowData?.createdUser}}" 
                                                        pTooltip="{{ rowData?.createdBy }}"
                                                        tooltipPosition="top" 
                                                        shape="circle" 
                                                        class="p-mr-1 custom-circle"
                                                        [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff' }" 
                                                    />
                                                </p-avatarGroup>
                                            } @else if (col.columnName == 'updatedBy' && rowData.updatedBy) {
                                                <p-avatarGroup styleClass="mb-3">
                                                    <p-avatar 
                                                        label="{{rowData?.updatedUser}}" 
                                                        pTooltip="{{ rowData?.updatedBy }}"
                                                        tooltipPosition="top" 
                                                        shape="circle" 
                                                        class="p-mr-1 custom-circle"
                                                        [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff' }" 
                                                    />
                                                </p-avatarGroup>
                                            } @else if (col.columnName == 'reassignTo' && rowData.reassignUser?.length > 0) {
                                                <p-avatarGroup styleClass="mb-3">
                                                    <p-avatar
                                                        label="{{ rowData?.reassignUser[getReassignedUserIndex(rowData)]?.assignedUser }}"
                                                        tooltipPosition="top" 
                                                        pTooltip="{{ rowData?.reassignTo }}" 
                                                        shape="circle"
                                                        class="p-mr-1 custom-circle"
                                                        [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff' }" 
                                                    />
                                                    @if (rowData?.reassignUser?.length > 1) {
                                                        <p-avatar 
                                                            label="+{{rowData?.reassignUser?.length -1}}" 
                                                            shape="circle"
                                                            class="custom-circle" 
                                                            styleClass="p-ml-2"
                                                            [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff'}"
                                                            pTooltip="{{ rowData?.reassignTo }}" 
                                                            tooltipPosition="top" 
                                                        />
                                                    }
                                                </p-avatarGroup>
                                            } @else if (col.columnName == 'sharedUser' && rowData.sharedUser?.length > 0) {
                                                <p-avatarGroup styleClass="mb-3">
                                                    <p-avatar 
                                                        label="{{ rowData?.sharedUser[getSharedUserIndex(rowData)]?.assignedUser }}"
                                                        tooltipPosition="top" 
                                                        pTooltip="{{ rowData?.sharedTo }}" 
                                                        shape="circle"
                                                        class="p-mr-1 custom-circle"
                                                        [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff' }" 
                                                    />
                                                    @if (rowData?.sharedUser?.length > 1) {
                                                        <p-avatar 
                                                            label="+{{rowData?.sharedUser?.length -1}}" 
                                                            shape="circle"
                                                            class="custom-circle" 
                                                            styleClass="p-ml-2"
                                                            [style]="{ 'background-color': 'var(--primary-color)', color: '#ffffff'}"
                                                            pTooltip="{{ rowData.sharedTo }}" 
                                                            tooltipPosition="top" 
                                                        />
                                                    }
                                                </p-avatarGroup>
                                            } @else if (col.columnName === 'priority') {
                                                <p-tag [value]="rowData[col.columnName]"
                                                      [style]="{'background-color': rowData.priorityColor}">
                                                </p-tag>
                                            } @else if (col.columnName === 'status') {
                                                <p-tag [value]="rowData[col.columnName]"
                                                      [style]="{'background-color': rowData.statusColor}">
                                                </p-tag>
                                            } @else if (col.columnName === 'completionStatus') {
                                                <span class="p-ml-1" id="label_status">
                                                    <strong>{{rowData.completedTask}}/{{rowData.totalTask}} Completed</strong>
                                                </span>
                                                <p-progressBar 
                                                    class="progress-bar-margin-top" 
                                                    [style]="{ width: '9rem', height:'0.8rem'}"
                                                    aria-labelledby="label_status" 
                                                    [showValue]="true"
                                                    [value]="getCompletionRatio(rowData.completedTask,rowData.totalTask)">
                                                </p-progressBar>
                                            } @else {
                                                @if (col.columnName !== 'priority' && 
                                                     col.columnName !== 'status' && 
                                                     col.columnName !== 'createdBy' && 
                                                     col.columnName !== 'updatedBy' && 
                                                     col.columnName !== 'reassignTo' && 
                                                     col.columnName !== 'sharedUser' && 
                                                     !(col.columnName == 'assignedTo')) {
                                                    {{ rowData[col.columnName] | shorten:50 }}
                                                }
                                            }
                                        }
                                    }
                                }
                            </td>
                        }
                    }
                </tr>
            }
            <tr *ngIf="selectedGroupByValue && rowData?.expanded" style="margin-bottom: 5px;">
                <td colspan="30" style="padding: 0px!important;">
                    <p-paginator styleClass="child-paginator" (onPageChange)="onListPageChange($event,rowData)" [showCurrentPageReport]="true"
                        [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'" [first]="(rowData.pageNumber-1)"
                        [rows]="rowData.pageSize" [totalRecords]="rowData.totalCount">
                    </p-paginator>
                </td>
            </tr>
        <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns" #depth>
            <ng-template [ngTemplateOutlet]="Recursion"
                [ngTemplateOutletContext]="{$implicit: rowData, columns:columns}"></ng-template>
        </ng-template>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="30"><div class="p-tex-center">{{ noLeadFindOrLoadingText }}</div></td>
            </tr>
        </ng-template>
    </p-table>
</ng-container>

@if(isCopyTask){
<app-shared-create-task [headerTitle]="'Copy Task'" [isCopyTask]="isCopyTask"
    [displayAddEditDialog]="displayAddEditDialog" [selectedTaskId]="selectedTask" (loadNewList)="loadNewList()"
    (cancelClicked)="closeTaskEdit()">
</app-shared-create-task>
}